import React, { useEffect } from 'react';

class Restricted extends React.Component {
  componentDidMount() {
    window.addEventListener('beforeunload', this.handleUnload);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleUnload);
  }

  handleUnload = (e) => {
    e.preventDefault();
    e.returnValue = '';
  };

  render() {
    return (
      <div>
      </div>
    );
  }
}

export { Restricted };

//ブラウザを閉じたりリロードをする時に警告を出すためのコンポーネント